/**
 * Read a file, center-crop to square, resize to maxSize, return JPEG data URL.
 * Used for personal specimen photos (no wobbly mask).
 */
export function fileToSquareJpeg(file, maxSize = 800, quality = 0.85) {
  return new Promise((resolve, reject) => {
    if (!file || !file.type?.startsWith("image/")) {
      reject(new Error("Pick an image"));
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Could not read file"));
    reader.onload = (ev) => {
      const img = new Image();
      img.onerror = () => reject(new Error("Could not load image"));
      img.onload = () => {
        const s = Math.min(img.naturalWidth, img.naturalHeight);
        const sx = (img.naturalWidth - s) / 2;
        const sy = (img.naturalHeight - s) / 2;
        const c = document.createElement("canvas");
        c.width = maxSize; c.height = maxSize;
        const ctx = c.getContext("2d");
        ctx.fillStyle = "#FBF7EC";
        ctx.fillRect(0, 0, maxSize, maxSize);
        ctx.drawImage(img, sx, sy, s, s, 0, 0, maxSize, maxSize);
        resolve(c.toDataURL("image/jpeg", quality));
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  });
}
